module.exports = __webpack_public_path__ + "img/16.70e012f0.jpg";